import * as actionTypes from './actionTypes';
import { Dispatch } from 'redux';

export interface StartFlowPayload {
	correlationKey: string;
	flowId: string;
	flowUniqueToken: string | null;
	decisionSupportSessionId: string | null;
	productInstanceId: number;
	inputFields: any;
	enableDebugging: boolean;
	debuggerFlowInputs: any[] | null;
	debugPathFileContents: any | null;
	patientReferenceId: string | null;
	careOrderVisitIdentifier: string | undefined;
}

export function startFlow(startFlow: StartFlowPayload) {
	return {
		type: actionTypes.GUIDED_RESPONSE_START_FLOW,
		startFlow,
		payload: {
			request: {
				method: 'post',
				url: `guidedresponse/runtime/start?flowId=${startFlow.flowId}`,
				data: startFlow,
			},
		},
	};
}

export function continueFlow(flowSessionId: string, userResponses: any) {
	return {
		type: actionTypes.GUIDED_RESPONSE_CONTINUE_FLOW,
		flowSessionId,
		userResponses,
		payload: {
			request: {
				method: 'post',
				url: `guidedresponse/runtime/continue?flowSessionId=${flowSessionId}`,
				data: userResponses,
			},
		},
	};
}

export function previous(flowSessionId: string) {
	return {
		type: actionTypes.GUIDED_RESPONSE_PREVIOUS,
		flowSessionId,
		payload: {
			request: {
				method: 'post',
				url: `guidedresponse/runtime/previous?flowSessionId=${flowSessionId}`,
				data: {},
			},
		},
	};
}

export function getFlowDebugPathFile(flowSessionId: string, token: string) {
	return {
		type: actionTypes.GUIDED_RESPONSE_DEBUG_PATH,
		payload: {
			request: {
				method: 'get',
				url: `guidedresponse/debugpath/${flowSessionId}`,
			},
		},
		headers: {
			token,
		},
	};
}

export function getSessionQuestionsAndAnswers(decisionSupportSessionId: string) {
	return {
		type: actionTypes.GET_SESSION_QUESTIONS_AND_ANSWERS,
		payload: {
			request: {
				method: 'get',
				url: `guidedresponse/sessionquestionsandanswers/${decisionSupportSessionId}`,
			},
		},
	};
}

export function attachPatientToDecisionSupportSession(
	decisionSupportSessionId: string,
	patientReferenceId: string,
) {
	return {
		type: actionTypes.ATTACH_PATIENT_TO_DECISION_SUPPORT_SESSION,
		payload: {
			request: {
				method: 'put',
				url: `decisionsupportsession/${decisionSupportSessionId}/patient/${patientReferenceId}`,
			},
		},
	};
}

export function clearSessionQuestionsAndAnswers() {
	return {
		type: actionTypes.CLEAR_SESSION_QUESTIONS_AND_ANSWERS,
	};
}

export function getSession(flowSessionId: string) {
	return {
		type: actionTypes.GUIDED_RESPONSE_GET_FLOW_SESSION,
		payload: {
			request: {
				method: 'post',
				url: `guidedresponse/runtime/session?flowSessionId=${flowSessionId}`,
			},
		},
	};
}

// TODO: The below methods will be deprecated when new Resume endpoint is implemented
function saveAnsweredQuestionsAction(questions: any[]) {
	return {
		type: actionTypes.GUIDED_RESPONSE_SAVE_FINISHED_QUESTIONS,
		data: questions,
	};
}

export function saveAnsweredQuestions(questions: any[]) {
	return function (dispatch: Dispatch) {
		dispatch(saveAnsweredQuestionsAction(questions));
	};
}

export function getDSVResults(flowSessionId: string) {
	return {
		type: actionTypes.GET_GUIDED_RESPONSE_DSV_RESULTS,
		payload: {
			request: {
				method: 'get',
				url: `guidedresponse/dsv/verbiageresults/${flowSessionId}`,
			},
		},
	};
}
